export const environment = {
	production: true,
	isMockEnabled: true, // You have to switch this, when your real back-end is done
	authTokenKey: 'authce9d77b308c149d5992a80073637e4d5',
	sentry: {
		//dsn: "http://c20cda4ca3d446e98ac35129afcbb32e@sentry.vnetgps.com:9000/27",
		dsn: "",
	},
	api: {
		// host: 'https://dev.vnetgps.com/api',
		// host: 'http://192.168.1.67:8080/api',
		// host: 'http://demo2.vnetgps.com/api',
		// host: 'http://125.212.203.173:9191/api',
		// host: 'https://demo.vnetgps.com/api',//DEMO
		host: 'https://www.gpsvnet.com/api',//PROD
		// host: 'http://topgps.vnetgps.com/api',//PROD TOPGGPS NEW
		// host: 'http://demo2.vnetgps.com/api',//DEMO TOPGGPS NEW
		// host: 'http://old.gpsvnet.com/api', //TOPGPS OLD
		// host: 'http://125.212.203.98:9191/api', //NEW SERVER
		// host: 'http://172.23.10.2:9090/api',
		// host: 'https://dev.vnetgps.com/api',//DEV
		// host: 'http://localhost:9090/api',
		AppID: 'Mr2n4FaCO8XdS7K6x4sHbIT6L+Gumltq7dy/EW0eIXQ=',
	},
	googleMapKey: 'AIzaSyDZbYx6ZOJH2e7uAbVwlC0dwDrsnq_NdTs',
	osrm: {
		host: 'http://125.212.203.173:5000'
	},
	hostAllow: [
		'https://free.currconv.com',
		'https://free.currconv.com/api/v7/convert',
		// 'http://admin.haduwaco.com',
		'http://192.168.1.67:8080',
		'http://demo2.vnetgps.com/api',
		'https://www.gpsvnet.com/api',
		'http://125.212.203.173:9191/api',
		'https://dev.vnetgps.com/api',
		'https://demo.vnetgps.com/api',
		'https://dev.vnetgps.com/api',
		'http://localhost:9090/api',
		'http://125.212.203.98:9191/api',
		'http://172.23.10.2:9090/api',
		'http://topgps.vnetgps.com/api',
		'http://demo2.vnetgps.com/api',
		'http://old.gpsvnet.com/api',
	],
	googleAPI: {
		keyCheck: "loadedGoogleAPIKey",
		keys: [
			"AIzaSyAuOeulBHio0-7NOKkxHwXjp8sm_OmkkoY"
			// "AIzaSyCKuGwuar9Gd2tDbJSH3PXRp1ldPy-37Sk",
			// "AIzaSyArGxW1GDWHDxa_iIjGyRV1pgdXZ7opTh0"
		],
	},
	mqtt: {
		server: 'broker.hivemq.com',
		protocol: "wss",
		port: 8000
	},
	// hostImage: 'http://admin.haduwaco.com',
	version: "v 1.3.8",

};
